import { render, staticRenderFns } from "./ManagePhoto.vue?vue&type=template&id=2265f843&scoped=true&"
import script from "./ManagePhoto.vue?vue&type=script&lang=js&"
export * from "./ManagePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ManagePhoto.vue?vue&type=style&index=0&id=2265f843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265f843",
  null
  
)

export default component.exports